import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M19.59 7L12 14.59 6.41 9H11V7H3v8h2v-4.59l7 7 9-9L19.59 7z"
}), 'CallMissedSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CallMissedSharp.js
// module id = 2612
// module chunks = 2